"use strict";

var $ = require("jquery");
var uuid = require("./uuidMIT");

// instead of doing any extra logic to generate these strings, let's just keep it dead simple for now
function getEmailOrTextHint(emailHint, textHint, locale) {
    return {
        hint: locale.receiveLocaleWidget.emailHint +" <strong>" + emailHint + " </strong> "+locale.receiveLocaleWidget.textHint+  " <strong>" + textHint + "</strong>?"
    };
}

function getEmailMeText(emailHint, locale) {
    return {
        hint: locale.receiveLocaleWidget.emailMeHint +" <strong>" + emailHint + "</strong>.",
        confirmation: locale.enterLocaleWidget.emailMeHint +" <strong>" + emailHint + "</strong>." +" "+locale.enterLocaleWidget.emailExpire
    };
}

function getTextMeText(textMeHint, locale) {
    return {
        hint: locale.receiveLocaleWidget.textMeHint +" <strong>" + textMeHint + "</strong>.",
        confirmation: locale.enterLocaleWidget.textMeHint +" <strong>" + textMeHint + "</strong>." +" "+locale.enterLocaleWidget.textExpire
    };
}

function MultiFactorAuthentication (params) {
    this.loginWidgetInstance = params.loginWidgetInstance;
    this.mfaChallenge = params.mfaChallenge;
}

MultiFactorAuthentication.prototype.init = function (requestId) {
    var self = this;

    this.receiveTokenParent = this.loginWidgetInstance.mfaParent.find(".receive-token");
    this.enterTokenParent = this.loginWidgetInstance.mfaParent.find(".enter-token");
    this.tokenInputField = this.enterTokenParent.find("input.token-input-field");

    // Due to the order of the Cancel and Submit buttons in the DOM, the Cancel button is used as the for submit action
    // when the user hits enter when the token input field is in focus.  The keypress event needs to be overridden so that
    // that it can block the default behavior and instead click the submit button.
    this.tokenInputField.on("keypress.mfa", function (event) {
        if (event.which == 13) {
            event.preventDefault();
            self.enterTokenParent.find("input.submit").click();
        }
    });

    this.enterTokenParent.hide();
    this.enterTokenParent.find(".bad-token").hide();

    var deliveryOptions = this.mfaChallenge.deliveryOptions;
    var enableTextMeOption = { enabled: false, hint: "" };
    var enableEmailMeOption = { enabled: false, hint: "" };
    var locale = this.loginWidgetInstance;

    for (var optionIndex = 0; optionIndex < deliveryOptions.length; optionIndex++) {
        var deliveryOption = deliveryOptions[optionIndex];
        if (!deliveryOption.medium) { continue; }

        if (deliveryOption.medium === "SMS") {
            enableTextMeOption.enabled = true;
            enableTextMeOption.hint = deliveryOption.hint;
        }

        if (deliveryOption.medium === "EMAIL") {
            enableEmailMeOption.enabled = true;
            enableEmailMeOption.hint = deliveryOption.hint;
        }
    }

    this.setHintsAndConfirmationText(enableEmailMeOption, enableTextMeOption, locale);

    function onCancel (e) {
        e.preventDefault();
        self.tokenInputField.val("");
        self.receiveTokenParent.show();
        self.receiveTokenParent.find("*").off(".mfa");
        self.enterTokenParent.hide();
        self.enterTokenParent.find("*").off(".mfa");
        self.loginWidgetInstance.resetToDefault();
		
	self.receiveTokenParent.find(".email-text-inform").hide();
	self.receiveTokenParent.find(".email-inform").hide();
    }

    // receive token step bindings
    this.receiveTokenParent.find("input.cancel").on("click.mfa", onCancel);
    this.receiveTokenParent.find("input.emailme").on("click.mfa", function (e) {
        e.preventDefault();
        self.sendToken("EMAIL", requestId);
    });

    this.receiveTokenParent.find("input.textme").on("click.mfa", function (e) {
        e.preventDefault();
        self.sendToken("SMS",requestId);
    });

    // enter token step bindings
    this.enterTokenParent.find("input.cancel").on("click.mfa", onCancel);
    this.enterTokenParent.find("input.submit").on("click.mfa enter.mfa", function (e) {
        e.preventDefault();
        self.submitToken(requestId);
    });
    this.enterTokenParent.find(".uim-resend-code").on("click.mfa", function (e) {
        e.preventDefault();
        self.tokenInputField.val("");
        self.receiveTokenParent.show();
        self.enterTokenParent.hide();
    });
};

MultiFactorAuthentication.prototype.setHintsAndConfirmationText = function (enableEmailMeOption, enableTextMeOption, locale) {
    var message = {};

    if (enableEmailMeOption.enabled && enableTextMeOption.enabled) {
        message = getEmailOrTextHint(enableEmailMeOption.hint, enableTextMeOption.hint, locale);
    } else if (enableEmailMeOption.enabled) {
        message = getEmailMeText(enableEmailMeOption.hint, locale);
        this.receiveTokenParent.find(".textme").hide();
    } else if (enableTextMeOption.enabled) {
        message = getTextMeText(enableTextMeOption.hint, locale);
        this.receiveTokenParent.find(".emailme").hide();
    }

    this.receiveTokenParent.find("p.hint").html(message.hint);
    this.enterTokenParent.find("p.confirmation").html(message.confirmation);
};

// how to receive token steps
MultiFactorAuthentication.prototype.sendToken = function (methodOfSendingToken, requestId) {
    var self = this;
	
    self.receiveTokenParent.find(".email-text-inform").hide();
    self.receiveTokenParent.find(".email-inform").hide();
		
    if("EMAIL"==methodOfSendingToken){
        self.receiveTokenParent.find(".emailme").attr('disabled',"true");	
    }else if("SMS"==methodOfSendingToken){
        self.receiveTokenParent.find(".textme").attr('disabled',"true");	
    }
    
    var url = "";
    var SEND_TOKEN_PATH = "/sso/json/msusers/authenticate?authIndexType=service&authIndexValue=mfaService";
    if (typeof this.loginWidgetInstance.proxyBaseUrl === "string") {
        url = this.loginWidgetInstance.proxyBaseUrl + SEND_TOKEN_PATH;
    } else {
        url = this.loginWidgetInstance.baseUrl + SEND_TOKEN_PATH;
    }

    $.ajax({
        method: "POST",
        url: url,
        xhrFields: {
            withCredentials: true
        },
        data: "",
        headers: {
            "Content-Type": "application/json",
            "X-OpenAM-Username": this.mfaChallenge.transactionID,
            "X-OpenAM-Password": "START:" + methodOfSendingToken,
            "X-API-RequestId": requestId
        }
    })
    .error(function (response, status, error) {
        // API returns 401, so error will get thrown	
	if("EMAIL"==methodOfSendingToken){         
		self.receiveTokenParent.find(".emailme").removeAttr("disabled");
	}else if("SMS"==methodOfSendingToken){
		self.receiveTokenParent.find(".textme").removeAttr("disabled");
	}
	
	//{"status":"SUCCESS"}
	var otp_status = response.getResponseHeader("OTP_RESPONSE");
	var res_status = response.status;
	if('{"status":"SUCCESS"}'==otp_status && "401"==res_status){
			
		self.receiveTokenParent.find(".email-text-inform").hide();
		self.receiveTokenParent.find(".email-inform").hide();
			
		self.receiveTokenParent.hide();
		self.enterTokenParent.find(".bad-token").hide();
		self.enterTokenParent.find(".input-area").removeClass("error");
		self.enterTokenParent.show();
	}else{
		if("EMAIL"==methodOfSendingToken){         
			self.receiveTokenParent.find(".email-inform").show();
		}else if("SMS"==methodOfSendingToken){
			self.receiveTokenParent.find(".email-text-inform").show();
		}
	}
	
    })
    .success(function (data, status) {
        // success should never get thrown, so let's switch the view just incase
	if("EMAIL"==methodOfSendingToken){         
		self.receiveTokenParent.find(".emailme").removeAttr("disabled");
	}else if("SMS"==methodOfSendingToken){
		self.receiveTokenParent.find(".textme").removeAttr("disabled");
	}
			
	self.receiveTokenParent.hide();
	self.enterTokenParent.show();
    });
};

MultiFactorAuthentication.prototype.validateTokenInput = function (responseIsInvalid) {
    var tokenValue = this.tokenInputField.val();
    var isInValid = tokenValue === undefined || tokenValue === null || tokenValue === "";

    var inputErrorField = this.enterTokenParent.find(".bad-token");
    if (isInValid || responseIsInvalid) {
        this.enterTokenParent.find(".input-area").addClass("error");
        inputErrorField.show();
    } else {
        this.enterTokenParent.find(".input-area").removeClass("error");
        inputErrorField.hide();
    }

    return isInValid;
};

// enter token steps
MultiFactorAuthentication.prototype.submitToken = function (requestId) {
    var self = this;
    var isInValid = this.validateTokenInput();
    if (isInValid) { return; }

    var token = this.tokenInputField.val();
    this.loginWidgetInstance.submit({
        username: this.mfaChallenge.transactionID,
        password: "FINISH:" + token,
        isMFAResponse: true,
        requestId: requestId
    }, function (response, status, error) {
        self.validateTokenInput(true);
    });
};


module.exports = MultiFactorAuthentication;



//////////////////
// WEBPACK FOOTER
// ./components/ui-widgets/src/js/multi_factor_auth.js
// module id = 33
// module chunks = 0